if (window.MktoForms2) {
  (function addWebsiteValidation() {
    MktoForms2.whenReady(async function formReadyCallback(form) {
      const formElem = form.getFormElem();
      const websiteField = formElem.find("#Website");
      const errorMessage = await getErrorMessage(form.getId());
      if (websiteField.length >= 1) {
        let touched = false;
        addInvalidStyles();
        websiteField.on("blur", function updateTouched() {
          touched = true;
        });
        websiteField.on("click", function validateOnFocus() {
          if (touched) {
            validateWebsite(form, errorMessage, true, false);
          }
        });
        websiteField.on("input", function validateOnInput() {
          validateWebsite(form, errorMessage, touched);
        });
        form.onValidate(function validateOnFormValidation() {
          if (touched) {
            validateWebsite(form, errorMessage);
          }
        });
      }
    });
  })();
}

function validateWebsite(form, errorMessage, showError = true, shake = true) {
  form.submittable(false);
  const value = form.vals().Website;
  const validWebsiteRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g;
  const websiteValid = value.match(validWebsiteRegex);
  const websiteField = form.getFormElem().find("#Website");
  const websiteLabel = form.getFormElem().find("#Website ~ label");
  if (!websiteValid) {
    websiteField.parent().addClass("force-invalid");
    if (!websiteField.parent().find(".mktoError")[0] && showError) {
      form.showErrorMessage(errorMessage, websiteField);
    }
    if (
      websiteLabel.hasClass("mdc-floating-label--float-above") &&
      document.activeElement == websiteField[0] &&
      shake
    ) {
      websiteLabel.addClass("mdc-floating-label--shake");
    }
    const firstInvalidInput = form
      .getFormElem()
      .find(".mktoInvalid, .force-invalid input")[0];
    if (firstInvalidInput && firstInvalidInput == websiteField[0]) {
      websiteField.focus();
    }
  } else {
    websiteField.parent().removeClass("force-invalid");
    websiteLabel.removeClass("mdc-floating-label--shake");
    form.submittable(true);
  }
}

async function getErrorMessage(id) {
  const fieldData = await fetch(
    `https://app-sj24.marketo.com/index.php/form/getForm?munchkinId=808-GJW-314&form=${id}&url=${encodeURIComponent(
      window.location.href
    )}`,
    {
      credentials: "omit",
      headers: { "sec-fetch-mode": "no-cors" },
      referrer: window.location.href,
      referrerPolicy: "no-referrer-when-downgrade",
      body: null,
      method: "GET",
      mode: "cors"
    }
  )
    .then(d => d.json())
    .then(data => data.rows)
    .catch(() => {
      return "Must be a url. http://www.example.com/";
    });
  if (typeof fieldData == "string") {
    return fieldData;
  } else {
    const websiteField = fieldData.filter(function checkForWebsite(row) {
      return row[0].Name == "Website";
    });
    return websiteField[0][0].ValidationMessage;
  }
}

function addInvalidStyles() {
  const styles = ` .mdc-text-field.force-invalid:not(.mdc-text-field--disabled) .mdc-floating-label {
      color: #b00020 !important;
  }

  .mdc-text-field.force-invalid:not(.mdc-text-field--disabled) #Website ~ .mktoError {
    display: block !important;
    opacity: 1 !important;
    animation: fade-in .25s 1;
  }

  .mdc-text-field.force-invalid:not(.mdc-text-field--disabled) .mdc-line-ripple {
      background-color: #b00020 !important;
      background-color: var(--mdc-theme-error, #b00020) !important;
  }

  .mdc-text-field.force-invalid:not(.mdc-text-field--disabled) .mdc-text-field__input {
      caret-color: #b00020 !important;
      caret-color: var(--mdc-theme-error, #b00020) !important;
      border-bottom-color: #b00020 !important;
      border-bottom-color: var(--mdc-theme-error, #b00020) !important;
  }
  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  `;

  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}
